import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Login } from '../pages/Login'
import { Contact } from '../pages/Contact'
import { Welcome } from '../pages/Welcome'
import { PageNotFound } from '../pages/PageNotFound'
import { RecoverPassword } from '../pages/RecoverPassword'
import ContextRecoverPasswordProvider from '../context/context_recoverPassword'
import { Privacity } from '../pages/Privacity'

export function UnauthRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Welcome />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/recuperar/senha"
        element={
          <ContextRecoverPasswordProvider>
            <RecoverPassword />
          </ContextRecoverPasswordProvider>
        }
      />
      <Route path="*" element={<Navigate to="/login" />} />
      <Route path="/contato" element={<Contact />} />
      <Route path="/privacidade" element={<Privacity />} />
    </Routes>
  )
}
